import { addDays, startOfDay } from 'date-fns';
const HIDDEN_VOUCHER_TYPES = [
    'home_office',
    'home office',
    'fuel',
    'combustivel',
    'combustível',
    'education',
    'educacao',
    'educação',
    'reward',
    'premiacao',
    'premiação',
];
export function isPayrollDeductionHidden(voucherType) {
    return HIDDEN_VOUCHER_TYPES.includes((voucherType ?? '').toLowerCase());
}
export function getDefaultCreditDate(now) {
    return addDays(startOfDay(now), 1);
}
export function formatDateForBR(date, locale = 'pt-BR') {
    if (!date)
        return '';
    return date.toLocaleDateString(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
}
export function formatDateForISO(date) {
    if (!date)
        return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export function getCompetenceString(competenceDate) {
    if (!competenceDate)
        return undefined;
    const year = competenceDate.getFullYear();
    const month = String(competenceDate.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
}
